/**
 * Directive: resourceAvailabiilityGrid
 */
angular.module('acme.common.directive.resourceAvailabiilityGrid', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.directive.dataGrid',
  'acme.view.application.dataGrid.controllers'
])
.directive('resourceAvailabiilityGrid', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceAvailabiilityGrid/resourceAvailabiilityGrid.tpl.html',
      scope: {
        eventId: '=',
        eventTemplateId: '=',
        privateSchedule: '=',
        resourceItem: '=',
        startDateTime: '=',
        duration: '=',
        selectedResourceItem: '=',
        searchType: '='
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: [
        '$scope',
        '$rootScope',
        '$state',
        '$timeout',
        'ApiService',
        'GridStateFactory',
        'GridDefinitionFactory',
        function(
          $scope,
          $rootScope,
          $state,
          $timeout,
          ApiService,
          GridStateFactory,
          GridDefinitionFactory
        ) {

        $scope.resourceAvailabiilityGrid = {

          model: [],

          gridState: new GridStateFactory(),
          gridDefinition: new GridDefinitionFactory(),

          viewId: '',
          gridName: $state.current.name + '.resourceAvailabiilityGrid.grid0',

          search: '',
          type: 'event',

          optionsOverride: {
            data: 'resourceAvailabiilityGrid.model',
            useAccessibleGrid: true,
            enableUnselect: true,
            hideHeaderInfo: true,
            enableGridMenu: false,
            paginationPageSize: 10,
            paginationPageSizes: [10],
            appScopeProvider: {
              onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
                $scope.resourceAvailabiilityGrid.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
              },
              onDataGridSortChange: function(grid, columns) {
                $scope.resourceAvailabiilityGrid.onDataGridSortChange(grid, columns);
              },
              onDataGridSelectionChange: function(row, e) {
                $scope.resourceAvailabiilityGrid.onRowSelectionChanged(row, e);
              }
            },
            columnDefs: [
              {
                field: 'resourceName',
                displayName: 'Name',
                colId: 'resourceName',
                sort: {
                  direction: 'asc'
                }
              },
              {
                field: 'available',
                displayName: 'Available',
                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="fa fa-check text-success" data-ng-show="row.entity.available"><span class="sr-only">Yes</span></span><span class="fa fa-ban text-danger" data-ng-hide="row.entity.available"><span class="sr-only">No</span></span></div>',
                width: 130
              },
              {
                field: 'conficts',
                displayName: 'No Conflicts',
                cellTemplate: '<div class="ui-grid-cell-contents text-center"><span class="fa fa-check text-success" data-ng-hide="row.entity.conflicts"><span class="sr-only">Yes</span></span><span class="fa fa-ban text-danger" data-ng-show="row.entity.conflicts"><span class="sr-only">No</span></span></div>',
                width: 130
              }
            ]
          },

          init: function() {

            if ($scope.searchType) {
              this.type = $scope.searchType;
            }

            this.initWatchers();
            this.viewId = $state.current.name;
            this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
            $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
            $scope.$on('DataGrid::RemoveSelection', this.onRemoveSelection);
            $scope.$on('ResourceAvailabiilityGrid::setSelection', this.onSetSelection);
            $scope.$on('ResourceAvailabiilityGrid::search', this.onSearch);
          },

          initWatchers: function() {
            $scope.$on('$destroy', $scope.$watch('resourceItem', this.onResourceItemUpdate));
          },

          initData: function() {
            var self = $scope.resourceAvailabiilityGrid,
                props = self.gridDefinition.getGridState();

            self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
            self.resourceAvailabiilityList();
          },

          resourceAvailabiilityList: function() {
            var props = {};

            if (this.type === 'event') {
              props = {
                id: $scope.resourceItem.id,
                eventId: $scope.eventId,
                resourceRequestId: $scope.resourceItem.eventInstanceResourceRequestId,
                startTime: moment($scope.startDateTime).format(),
                durationHour: '' + $scope.duration.hour,
                durationMinutes: '' + $scope.duration.minutes,
                match: 'true',
                available: 'false',
                resourceOwnerId: $scope.resourceItem.resourceOwnerId
              };

              this.gridState.setPropertyValue('search', this.search);

              ApiService.resource.assignment.resourceRequestPrivateEvent($.extend(props, this.gridState.getGridState())).then(this.success.resourceAvailabiilityList, this.error.resourceAvailabiilityList);
            }

            if (this.type === 'template') {
              props = {
                id: $scope.resourceItem.id,
                eventTemplateId: $scope.eventTemplateId,
                scheduleId: ($scope.privateSchedule)? $scope.privateSchedule.id: '',
                resourceRequestId: $scope.resourceItem.id,
                resourceTemplateId: $scope.resourceItem.resourceTemplateId,
                resourceCategory: $scope.resourceItem.resourceCategory,
                startTime: moment($scope.startDateTime).format(),
                durationHour: '' + $scope.duration.hour,
                durationMinutes: '' + $scope.duration.minutes,
                match: 'true',
                available: 'false'
              };

              this.gridState.setPropertyValue('search', this.search);

              ApiService.resource.assignment.resourceRequestPrivateEvent($.extend(props, this.gridState.getGridState())).then(this.success.resourceAvailabiilityList, this.error.resourceAvailabiilityList);
            }
          },

          processResources: function(list) {
            return list.map(function(item) {
              item.resourceTemplateNamesParsed = item.resourceTemplateNames.join(', ');
              return item;
            });
          },

          selectResource: function() {
            var i, ii,
                selected = [];

            $scope.$broadcast('DataGrid::clearSelection');

            if ($scope.resourceItem.resourceId) {
              for (i = 0, ii = this.model.length; i < ii; i++) {

                if (
                  this.model[i].resourceId &&
                  (!$scope.selectedResourceItem.hasOwnProperty('resourceId') && this.model[i].resourceId === $scope.resourceItem.resourceId) ||
                  ($scope.selectedResourceItem.hasOwnProperty('resourceId') && this.model[i].resourceId === $scope.selectedResourceItem.resourceId)
                ) {
                  selected.push(this.model[i]);
                  break;
                }
              }

              if (selected.length) {
                $scope.$broadcast('DataGrid::SetSelection', selected);
              }
            }
          },

          success: {
            resourceAvailabiilityList: function(res) {
              var self = $scope.resourceAvailabiilityGrid;

              self.model = self.processResources(res.data.payload.list);

              $timeout(function() {
                $scope.$broadcast('DataGrid::ResizeGrid', {
                  name: self.gridDefinition.options.gridName,
                  datasetLength: self.model.length,
                  totalItems: res.data.payload.pagination.count
                });

                  $timeout(function() {
                    self.selectResource();
                  });

                self.gridDefinition.isLoaded = true;

                $scope.$emit('ResourceAvailabiilityGrid::searchEnd');
              }, 10);
            }
          },

          error: {
            resourceAvailabiilityList: function(res) {}
          },

          onResourceItemUpdate: function(n,o) {
            $scope.selectedResourceItem = {};
            if (n && n!== o) {
              $scope.resourceAvailabiilityGrid.resourceAvailabiilityList();
            }
          },

          // Grid handlers`
          onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
            var self = $scope.resourceAvailabiilityGrid;

            self.gridState.updateGridState(newPage, pageSize);
            if (sortField) {
              self.gridState.updateGridState(null, null, sortField, null);
            }
            if(sortDirection) {
              self.gridState.updateGridState(null, null, null, sortDirection);
            }
            self.resourceAvailabiilityList();
          },

          onDataGridSortChange: function(grid, columns) {
            var self = $scope.resourceAvailabiilityGrid,
              data = columns[0];

            if(data) {
              self.gridState.updateGridState(null, null, data.field, data.sort.direction);
              self.resourceAvailabiilityList();
            }
          },

          onRowSelectionChanged: function(row) {
            $scope.selectedResourceItem = row.entity;
          },

          onRemoveSelection: function() {
            $scope.selectedResourceItem = false;
          },

          onSetSelection: function(e, data) {
            var self = $scope.resourceAvailabiilityGrid,
                selected = [];

            $scope.selectedResourceItem = false;
            
            if (data.resourceId) {
              for (i = 0, ii = self.model.length; i < ii; i++) {
                if (self.model[i].resourceId && self.model[i].resourceId === data.resourceId) {
                  selected.push(self.model[i]);
                  break;
                }
              }

              if (selected.length) {
                $scope.$broadcast('DataGrid::SetSelection', selected);
              }
            }
          },

          onSearch: function(e, data) {
            var self = $scope.resourceAvailabiilityGrid;
            $timeout(function() {
              self.search = data.search;
              self.resourceAvailabiilityList();
            });
          }
        };

        $scope.resourceAvailabiilityGrid.init();

      }]

    };

}]);
